import React, { useState, useEffect } from "react";
import Select from "react-select";
import { set_variant_list } from "../../core/redux/action";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Link } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
// import { bucketObj } from "../../environment";
// import { uploadImageNew } from "../../core/img/imagewithbasebath";
// import { PlusCircle } from "feather-icons-react/build/IconComponents";
import PropTypes from "prop-types";

const AddVariation = ({ onVariantsChange, productAttributes = [] }) => {
  
  const dispatch = useDispatch();
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const choose = t?.[l]?.["choose"];

  const [localProductAttributes, setLocalProductAttributes] = useState(
    productAttributes
  );
  const [generateVariantRowsState, setGenerateVariantRowsState] = useState([]);
  const [selectedVariants, setSelectedVariants] = useState([
    { id: 1, variant: null, attributes: [] },
  ]);

  const variants = useSelector((state) => {
    const variantList = state.variant_list || [];
    return [
      { label: choose || "Choose", value: "choose" },
      ...variantList.map((itm) => ({
        label: itm.name || "Unnamed Variant",
        value: itm._id,
        attributes: itm.attributes || "",
        customized: itm.customized,
      })),
    ];
  });

  useEffect(() => {
    async function fetchData() {
      try {
        const [variants] = await Promise.all([axios.get("getuservariants/")]);
        dispatch(set_variant_list(variants.data));
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, [dispatch]);

  // const handleInputChange2 = (e, rowIndex, row) => {
  //   // e.preventDefault();
  //   const { name, value } = e.target;
  //   if (!/^\d*\.?\d*$/.test(value)) return;

  //   const updatedProductAttributes = { ...localProductAttributes };
  //   if (!updatedProductAttributes.variants) {
  //     updatedProductAttributes.variants = [];
  //   }

  //   const sku = row.sku;
  //   const variantIndex = updatedProductAttributes.variants.findIndex(
  //     (variant) => variant?.sku === sku
  //   );

  //   if (variantIndex !== -1) {
  //     updatedProductAttributes.variants[variantIndex] = {
  //       ...updatedProductAttributes.variants[variantIndex],
  //       [name.split("-")[0]]: value,
  //     };
  //   } else {
  //     updatedProductAttributes.variants.push({
  //       ...row,
  //       sku,
  //       [name.split("-")[0]]: value,
  //     });
  //   }

  //   setLocalProductAttributes(updatedProductAttributes);
  //   const updatedRows = [...generateVariantRowsState];
  //   updatedRows[rowIndex] = {
  //     ...updatedRows[rowIndex],
  //     [name.split("-")[0]]: value,
  //   };
  //   setGenerateVariantRowsState(updatedRows);
  //   onVariantsChange(updatedProductAttributes.variants);
  // };


  // const handleInputChange3 = (selectedOption, rowIndex) => {
  //   const updatedRows = [...generateVariantRowsState];
  //   updatedRows[rowIndex] = {
  //     ...updatedRows[rowIndex],
  //     discountType: selectedOption.target.value,
  //   };
  //   setGenerateVariantRowsState(updatedRows);
  // };

  const handleInputChange2 = (e, rowIndex, row) => {
    const { name, value } = e.target ? e.target : { name: `discountType-${rowIndex}`, value: e.value };
    
    const updatedProductAttributes = { ...localProductAttributes };
    if (!updatedProductAttributes.variants) {
      updatedProductAttributes.variants = [];
    }
  
    const sku = row.sku;
    const variantIndex = updatedProductAttributes.variants.findIndex(
      (variant) => variant?.sku === sku
    );
  
    // Update the relevant property
    if (variantIndex !== -1) {
      updatedProductAttributes.variants[variantIndex] = {
        ...updatedProductAttributes.variants[variantIndex],
        [name.split("-")[0]]: value,
      };
    } else {
      updatedProductAttributes.variants.push({
        ...row,
        sku,
        [name.split("-")[0]]: value,
      });
    }
  
    // Update the local state for UI
    setLocalProductAttributes(updatedProductAttributes);
    const updatedRows = [...generateVariantRowsState];
    updatedRows[rowIndex] = {
      ...updatedRows[rowIndex],
      [name.split("-")[0]]: value,
    };
    setGenerateVariantRowsState(updatedRows);
    onVariantsChange(updatedProductAttributes.variants);
  };
  

  useEffect(() => {
    if (productAttributes?.length > 0) {
    //  eslint-disable-next-line no-debugger
    debugger;
      const initialRows = productAttributes.map((attr) => ({
        variant: attr.variant || "",
        attribute: attr.attribute,
        sku: attr.sku,
        // qty: attr.qty || 0,
        price: attr.price || "",
        discountType: attr.discountType || "choose",
        discountValue: attr.discountValue || 0,
        weight: attr.weight || "",
        // imgUrls: attr.imgUrls || [],
        expiry: attr.expiry || undefined
      }));

      setGenerateVariantRowsState(initialRows);
      
      setLocalProductAttributes({ ...localProductAttributes, variants: initialRows });
      onVariantsChange(initialRows);
      console.log('initialRows',initialRows);
  
      // Mapping `variant` and `attribute` fields correctly for `selectedVariants`
      const initialVariants = [];
    productAttributes.forEach((attr) => {
      const variantParts = attr.variant.split("|"); // Split "SizeTest|Color" into ["SizeTest", "Color"]
      const attributeParts = attr.attribute.split("|"); // Split "S|Black" into ["S", "Black"]

      variantParts.forEach((variant, index) => {
        const existingVariant = initialVariants.find((v) => v.variant === variant);
        
        if (existingVariant) {
          // Add unique attribute to the existing variant
          const attribute = attributeParts[index];
          if (!existingVariant.attributes.find((a) => a.value === attribute)) {
            existingVariant.attributes.push({ value: attribute, label: attribute });
          }
        } else {
          // Create a new variant entry if it does not exist
          initialVariants.push({
            variant: variant,
            attributes: [{ value: attributeParts[index], label: attributeParts[index] }],
          });
        }
      });
    });

    // Set up selectedVariants and generateVariantRowsState
    setSelectedVariants(
      initialVariants.map((variantObj) => ({
        variant: { value: variantObj.variant, label: variantObj.variant },
        attributes: variantObj.attributes,
      }))
    );

    setGenerateVariantRowsState(productAttributes);

    }
  }, []);

  const handleVariantChange = (index, selectedOption) => {
    if (
      selectedVariants.some(
        (v, i) => i !== index && v.variant?.value === selectedOption?.value
      )
    ) {
      alert("This variant is already selected.");
      return;
    }

    const newVariants = [...selectedVariants];
    const updatedProductAttributes = { ...localProductAttributes, variants: [] };
    newVariants[index].variant = selectedOption;

    if (selectedOption && selectedOption.value !== "choose") {
      const attributesArray = selectedOption.attributes
        .split(",")
        .map((attr) => ({ value: attr.trim(), label: attr.trim() }));

      newVariants[index].attributes = attributesArray;
      updatedProductAttributes.variants[index] = {
        variant: selectedOption.value,
        attributes: attributesArray,
        price: "",
        // qty: 0,
        expiry: undefined,
        weight: "",
        discountValue: 0,
        discountType: "choose",
        sku: "",
        // imgUrls: [],
      };
    } else {
      newVariants[index].attributes = [];
      updatedProductAttributes.variants[index] = {
        variant: null,
        attributes: [],
        price: "",
        qty: 0,
        expiry: undefined,
        weight: "",
        discountValue: 0,
        discountType: "choose",
        sku: "",
        // imgUrls: [],
      };
    }

    setLocalProductAttributes(updatedProductAttributes);
    setGenerateVariantRowsState(generateVariantRows());
    setSelectedVariants(newVariants);
  };

  const generateCombinations = (arr, prefix = []) => {
    if (arr.length === 0) return [prefix];

    const first = arr[0];
    const rest = arr.slice(1);
    const result = [];

    first.forEach((item) => {
      result.push(...generateCombinations(rest, [...prefix, item]));
    });

    return result;
  };

  const generateVariantRows = () => {
    if (selectedVariants.some((v) => !v.variant || v.variant.value === "choose")) {
      return [];
    }
    const variantLabel = selectedVariants.map((v) => v?.variant?.label).join("|");
    const attributeGroups = selectedVariants.map((v) =>
      v?.attributes?.map((attr) => attr.value)
    );

    if (attributeGroups.length > 0 && attributeGroups[0] !== "choose") {
      const result = [];
      const combinations = generateCombinations(attributeGroups);

      combinations.forEach((combination, index) => {
        result.push({
          variant: variantLabel,
          attribute: combination.join("|"),
          sku: `SKU${index + 1}`,
          qty: 0,
          price: "",
          expiry: undefined,
          discountValue: 0,
          weight: "",
          unit: 0,
          discountType: "",
          // imgUrls: [],
        });
      });

      return result;
    }

    return [];
  };

  // const handleImageUpload = async (event, rowIndex) => {
  //   const file = event.target.files[0];
  //   if (!file || !file.type.startsWith("image/")) {
  //     return alert("Please upload a valid image file.");
  //   }
  //   if (file.size / (1024 * 1024) > 5) {
  //     alert(t?.[l]?.["file_size_exceeds_5_mb_limit"] || "File size exceeds 5 MB limit");
  //     return;
  //   }

  //   try {
  //     const fileName = await uploadImageNew(file);
  //     setGenerateVariantRowsState((prev) => {
  //       const updatedRows = [...prev];
  //       if (!updatedRows[rowIndex].imgUrls) updatedRows[rowIndex].imgUrls = [];
  //       updatedRows[rowIndex].imgUrls.push(fileName);
  //       return updatedRows;
  //     });
  //   } catch (error) {
  //     console.error("Image upload error:", error);
  //   }
  // };

  // const removeImage = (rowIndex, imgIndex) => {
  //   setGenerateVariantRowsState((prev) => {
  //     const updatedRows = [...prev];
  //     if (updatedRows[rowIndex]?.imgUrls) {
  //       updatedRows[rowIndex].imgUrls.splice(imgIndex, 1);
  //     }
  //     return updatedRows;
  //   });
  // };

  const addVariant = (e) => {
    e.preventDefault();
    setSelectedVariants((prev) => [
      ...prev,
      { id: prev.length + 1, variant: null, attributes: [{ label: choose, value: "choose" }] },
    ]);
  };

  const removeVariant = (e, index) => {
    e.preventDefault();
    setSelectedVariants((prev) => prev.filter((_, i) => i !== index));
  };

  const removeRow = (e, rowIndex) => {
    e.preventDefault();
    const filteredData = generateVariantRowsState.filter((_, i) => i !== rowIndex);
    setGenerateVariantRowsState(filteredData);
  };

  const discounttype = [
    { value: "choose", label: choose },
    { value: "percentage", label: t?.[l]?.["percentage"] || "Percentage" },
  ];

  return (
    <div className="tab-content mb-4" id="pills-tabContent">
      <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
        <div className="row">
          {selectedVariants.map((variantObj, index) => (
            <div className="col-lg-12" key={variantObj.id}>
              <div className="row">
                <div className="col-lg-4 col-sm-12">
                  <div className="input-blocks add-product">
                    <label>{t?.[l]?.["variant"] || "Variant"}*</label>
                    <Select
                      className="select"
                      options={variants.filter(
                        (option) => option && (option.customized === false || option.customized == null)
                      )}
                      placeholder={choose}
                      value={variantObj.variant}
                      onChange={(selectedOption) => handleVariantChange(index, selectedOption)}
                    />
                  </div>
                </div>

                <div className="col-lg-4 col-sm-12">
                  <div className="input-blocks add-product">
                    <label>{t?.[l]?.["attributes"] || "Attributes"}*</label>
                    <CreatableSelect
                      className="select"
                      options={variantObj.attributes}
                      isMulti
                      placeholder={choose}
                      name={`attributes-${index}`}
                      value={variantObj.attributes}
                      onCreateOption={(inputValue) => {
                        const newOption = { label: inputValue, value: inputValue };
                        const updatedVariants = [...selectedVariants];
                        updatedVariants[index].attributes = [
                          ...updatedVariants[index].attributes,
                          newOption,
                        ];

                        setSelectedVariants(updatedVariants);
                        setGenerateVariantRowsState(generateVariantRows());
                        onVariantsChange(localProductAttributes.variants);
                      }}
                      onChange={(selectedOptions) => {
                        const updatedVariants = [...selectedVariants];
                        updatedVariants[index].attributes = selectedOptions;

                        setSelectedVariants(updatedVariants);
                        setGenerateVariantRowsState(generateVariantRows());
                        onVariantsChange(localProductAttributes.variants);
                      }}
                    />
                  </div>
                </div>

                <div className="col-lg-1 col-sm-12 mt-4">
                  <div className="input-blocks add-product mt-2">
                    {index > 0 ? (
                      <Link className="confirm-text p-2" onClick={(e) => removeVariant(e, index)}>
                        <i data-feather="trash-2" className="feather-trash-2" />
                      </Link>
                    ) : (
                      <Link className="me-2 p-2" to="#" onClick={(e) => addVariant(e)}>
                        <i data-feather="plus" className="feather-edit" />
                      </Link>
                    )}
                  </div>
                </div>

                <div className="col-lg-3 col-sm-12 mt-4">
                  <div className="input-blocks add-product mt-2"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {generateVariantRowsState.length > 0 && (
        <div className="table-responsive mt-4 mb-4">
          <table className="table">
            <thead className="">
              <tr>
                <th>{t?.[l]?.["variant"] || "Variant"}</th>
                <th>{t?.[l]?.["attributes"] || "Attributes"}</th>
                <th hidden>SKU</th>
                <th hidden>Quantity</th>
                <th>{t?.[l]?.["price"] || "Price"}</th>
                {/* <th>{t?.[l]?.["image"] || "Image"}</th> */}
                <th>{t?.[l]?.["weight"] || "Weight"}</th>
                <th>{t?.[l]?.["discount"] || "Discount"} (%)</th>
                <th>{t?.[l]?.["expiry"] || "Expiry (Days)"}</th>
                <th>{t?.[l]?.["action"] || "Action"}</th>
              </tr>
            </thead>
            <tbody>
              {generateVariantRowsState.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td  style={{ maxHeight: "80px", overflowY: "auto", whiteSpace: "normal" }}>{`${row.variant}`}</td>
                  <td  style={{ maxHeight: "80px", overflowY: "auto", whiteSpace: "normal" }}>{`${row.attribute}`}</td>
                  <td hidden>
                    <input
                      type="text"
                      name={`sku-${rowIndex}`}
                      defaultValue={row.sku}
                      onChange={(e) => {
                       
                        handleInputChange2(e, rowIndex, row);
                      }}
                    />
                  </td>
                  <td hidden>
                    <input
                      type="text"
                      name={`qty-${rowIndex}`}
                      defaultValue={row.qty}
                      onChange={(e) => {
                        
                        handleInputChange2(e, rowIndex, row);
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      name={`price-${rowIndex}`}
                      value={row.price || ""}
                      maxLength={10}
                      onChange={(e) => {
                        handleInputChange2(e, rowIndex, row);
                      }}
                    />
                  </td>
                 
                   <td>
  <div className="d-flex flex-column flex-sm-row">
    <input
      type="text"
      className="form-control mb-2 mb-sm-0"
      style={{ width: "100%", maxWidth: "65%" }}
      disabled
      name={`unit-${rowIndex}`}
      defaultValue="Kilogram (kg)"
    />
    <input
      type="text"
      className="form-control"
      style={{ width: "100%", maxWidth: "35%" }}
      name={`weight-${rowIndex}`}
      value={row.weight || ""}
      maxLength={8}
      onChange={(e) => handleInputChange2(e, rowIndex, row)}
    />
  </div>
</td>
<td>
  <div className="d-flex flex-column flex-sm-row">
    <Select
      className="select mb-2 mb-sm-0"
      style={{ width: "100%", maxWidth: "60%" }}
      options={discounttype}
      placeholder={choose}
      name={`discountType-${rowIndex}`}
      value={discounttype.find((option) => option.value === row.discountType)}
      onChange={(selectedOption) =>
        handleInputChange2(
          { value: selectedOption.value },
          rowIndex,
          row
        )
      }
    />
    <input
      type="text"
      className="form-control"
      style={{ width: "100%", maxWidth: "40%" }}
      name={`discountValue-${rowIndex}`}
      value={row.discountValue || ""}
      disabled={
        !generateVariantRowsState[rowIndex].discountType ||
        generateVariantRowsState[rowIndex].discountType === "choose"
      }
      onChange={(e) => handleInputChange2(e, rowIndex, row)}
    />
  </div>
</td>


                 
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      name={`expiry-${rowIndex}`}
                      value={row.expiry || ""}
                      maxLength={10}
                      onChange={(e) => {
                        handleInputChange2(e, rowIndex, row);
                      }}
                    />
                  </td>
                  <td>
                    <Link
                      className="confirm-text p-2"
                      to="#"
                      onClick={(e) => removeRow(e, rowIndex)}
                    >
                      <i data-feather="trash-2" className="feather-trash-2" />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

AddVariation.propTypes = {
  onVariantsChange: PropTypes.func.isRequired,
  productAttributes: PropTypes.array,
};

export default AddVariation;
 {/* <td>
                    <div
                      className="image-upload text-center"
                      onClick={() =>
                        document.getElementById(`coverInput-${rowIndex}`).click()
                      }
                      style={{
                        height: "100px",
                        border: "1px dashed #ddd",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        id={`coverInput-${rowIndex}`}
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageUpload(e, rowIndex)}
                        style={{ display: "none" }}
                      />
                      {row.imgUrls && row.imgUrls.length > 0 ? (
                        row.imgUrls.map((url, i) => (
                          <div
                            key={i}
                            className="position-relative"
                            style={{ display: "inline-block", margin: "5px" }}
                          >
                            <img
                              src={`${bucketObj.bucketUrl}${bucketObj.objectKey}${url}`}
                              alt={`Preview ${i}`}
                              style={{ maxWidth: "100px", maxHeight: "100px" }}
                            />
                            <button
                              type="button"
                              className="btn btn-danger position-absolute"
                              style={{
                                top: "-5px",
                                right: "-5px",
                                borderRadius: "50%",
                                width: "20px",
                                height: "20px",
                                padding: "0",
                                lineHeight: "1",
                                fontSize: "14px",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                removeImage(rowIndex, i);
                              }}
                            >
                              &times;
                            </button>
                          </div>
                        ))
                      ) : (
                        <div
                          className="text-center"
                          style={{ padding: "30px", color: "#999" }}
                        >
                          <PlusCircle className="plus-down-add me-0" />
                          <p>{t?.[l]?.["add_images"] || "Add Images"}</p>
                        </div>
                      )}
                    </div>
                  </td> */}



                   {/* <td>
                    <div className="d-flex">
                      <input
                        type="text"
                        className="form-control"
                        style={{ width: "55%" }}
                        disabled
                        name={`unit-${rowIndex}`}
                        defaultValue="Kilogram (kg)"
                      />
                      <input
                        type="text"
                        className="form-control"
                        style={{ width: "50%" }}
                        name={`weight-${rowIndex}`}
                        value={row.weight || ""}
                        maxLength={8}
                        onChange={(e) => {
                          handleInputChange2(e, rowIndex, row);
                        }}
                      />
                    </div>
                  </td> */}
                  {/* <td>
                    <div className="d-flex">
                      <Select
                        className="select"
                        style={{ width: "70%" }}
                        options={discounttype}
                        placeholder={choose}
                        name={`discountType-${rowIndex}`}
                        value={discounttype.find(
                          (option) => option.value === row.discountType
                        )}
                        onChange={(selectedOption) =>
                          handleInputChange2(
                            { value: selectedOption.value },
                            rowIndex,
                            row
                          )
                        }
                      />
                      <input
                        type="text"
                        style={{ width: "30%" }}
                        className="form-control"
                        name={`discountValue-${rowIndex}`}
                        value={row.discountValue || ""}
                        disabled={
                          !generateVariantRowsState[rowIndex].discountType ||
                          generateVariantRowsState[rowIndex].discountType === "choose"
                        }
                        onChange={(e) => {
                          handleInputChange2(e, rowIndex, row);
                        }}
                      />
                    </div>
                  </td> */}